<template>
  <VHtml :html="promoMessages" class="header-promo font-weight-bold" />
</template>

<script setup lang="ts">
import VHtml from '~/components/base/VHtml.vue'
import { useCartStore } from '~/stores/cart'

const $i18n = useI18n()

const cartStore = useCartStore()


const promoMessages = computed(() =>
  cartStore.summary.promotionSummary?.filter(promo => $i18n.has(`${promo.name}.ribbon.offerMessage`))
    .map(promo => $i18n.ts(`${promo.name}.ribbon.offerMessage`)).join(' / ')
)
</script>

<style lang='scss' scoped>
@use '~/assets/scss/settings';
@use 'sass:map';

.header-promo {
  font-size: 1rem;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  text-align: center;
  max-width: 100%;

  :deep(a) {
    color: white;
  }

  @media #{map.get(settings.$display-breakpoints, 'xs')} {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
